import { faCopy, faPenLine, faTrashCan } from "@fortawesome/pro-regular-svg-icons";

import { CircularProgress } from "@mui/material";

import { Icon } from "@/components";
import { Button } from "@/components/Button/Button";
import { clearMarkdownAndHTMLAndTrim } from "@/utils/clearMarkdownAndHTMLAndTrim";

import ToDoTag from "../../../ToDoList/components/ToDoTag";
import { ToDoInfo } from "../../../ToDoList/schema/to-do";

interface ViewModeToDoItemProps {
	data: ToDoInfo;
	setIsEditing: (value: number) => void;
	setCopyingToDo: (value: ToDoInfo | null) => void;
	isLoading?: boolean;
	setDeletingToDo: (value: ToDoInfo | null) => void;
}

export default function ViewModeToDoItem({
	data,
	setIsEditing,
	setCopyingToDo,
	isLoading,
	setDeletingToDo,
}: ViewModeToDoItemProps) {
	return (
		<div
			className="w-full rounded-xl p-4 bg-white flex gap-6"
			style={{ boxShadow: "0px 1px 2px 0px #1C274C1F" }}
		>
			{isLoading && <CircularProgress className="!w-10 !h-10 mx-auto" />}
			{!isLoading && (
				<>
					<div className="w-full">
						<div className="w-full space-x-2 flex items-center justify-start mb-2">
							<ToDoTag
								className="inline-flex items-center justify-center !max-h-[25px] !text-[12px]"
								title={data?.tag?.name ?? ""}
							/>
						</div>
						<div className="w-full flex items-center justify-start max-w-[calc(100%-208px)] flex-wrap">
							{data.industries?.map((industry) => (
								<ToDoTag
									key={industry.id}
									className="!ml-0 !mr-2 mb-2 inline-block leading-4 items-center text-ellipsis text-nowrap overflow-hidden w-fit !max-w-[200px] !max-h-[25px] !text-[12px]"
									style={{ backgroundColor: `#1A82451F`, color: "#1A8245" }}
									title={industry.name}
								/>
							))}
						</div>
						<h4 className={`text-primary-blue-dark text-[14px] font-semibold mt-3 mb-[6px]`}>
							{data.title}
						</h4>
						<p className={`text-[#777D8D] text-[12px] leading-4`}>
							{clearMarkdownAndHTMLAndTrim(data?.description ?? "", 400)}
						</p>
					</div>
					<div className="flex gap-2">
						<Button
							className="rounded-[12px] bg-white !min-w-[44px] !min-h-[44px] !max-w-[44px] !max-h-[44px] !p-0 !border-[0.28px] !border-[#E6E6EC] hover:bg-primary-gray-lightest"
							image={<Icon className="text-primary-blue-dark w-5 h-5" icon={faPenLine} />}
							title=""
							onClick={() => {
								if (data?.id) {
									setIsEditing(data?.id);
								}
							}}
						/>
						<Button
							className="rounded-[12px] bg-white !min-w-[44px] !min-h-[44px] !max-w-[44px] !max-h-[44px] !p-0 !border-[0.28px] !border-[#E6E6EC] hover:bg-primary-gray-lightest"
							image={<Icon className="text-primary-blue-dark w-5 h-5" icon={faCopy} />}
							title=""
							onClick={() => {
								if (data?.id) {
									setCopyingToDo(data);
								}
							}}
						/>
						<Button
							className="rounded-[12px] bg-white !min-w-[44px] !min-h-[44px] !max-w-[44px] !max-h-[44px] !p-0 !border-[0.28px] !border-[#E6E6EC] hover:bg-primary-gray-lightest"
							image={<Icon className="text-primary-blue-dark w-5 h-5" icon={faTrashCan} />}
							title=""
							onClick={() => {
								if (data?.id) {
									setDeletingToDo(data);
								}
							}}
						/>
					</div>
				</>
			)}
		</div>
	);
}
